import React, { useState, useEffect }  from 'react';
import MyEventListener from 'components/common/MyEventListener.jsx'
import { GetRequest } from 'components/common/index.js';

// defaultCatalogName: the catalog name the page shows, the drawing's own or one
// of its technical property combinations', which is a favourite of its own. The
// dieline page passes it and follows the combination drawn
// (drawing.catalog_name_changed); a page without one favourites the drawing.
const AddToFavourites = ( { defaultId, defaultCatalogName } ) => {

  const [id, setId] = useState(defaultId);
  const [catalogName, setCatalogName] = useState(defaultCatalogName);
  const [favourites, setFavourites] = useState({ catalog_names: [], drawing_ids: [] });
  const [hidden, setHidden] = useState(true);
  const [inProgress, setInProgress] = useState(false);

  // A drawing id arrives as a string after a drawing switch (window.drawing_id_changed).
  const favourited = catalogName ? favourites.catalog_names.includes(catalogName) : favourites.drawing_ids.some((drawingId) => drawingId == id);

  const getUserFavourites = () => {
    GetRequest({
      url:  "/user_favourite_catalog_names",
      callback: (data) => {
        setHidden( () => false )
        setFavourites( () => data )
      },
      401: () => {
        setHidden( () => true )
      }
    })
  }

  const handleClick = (e) => {
    e.preventDefault();
    if(inProgress) { return }
    setInProgress( () => true )

    $.ajax({
      type: "POST",
      url: "/user_favourites",
      data: {
        id: id,
        catalog_name: catalogName,
        value: !favourited,
        authenticity_token: $('meta[name=csrf-token]').attr('content')
      },
      success: function () {
        getUserFavourites()
        setTimeout( () => { setInProgress( () => false ) }, 300 );

      }
    });
  }

  // useEffect
  useEffect(getUserFavourites, [id])
  // useEffect

  MyEventListener([
    {
      key: 'user.session_started',
      callback: () => { setTimeout(getUserFavourites, 250) }
    }, {
      key: 'window.drawing_id_changed',
      callback: (msg) => {
        if(msg.detail.id == id) { return }
        setId( () => msg.detail.id )
        setCatalogName( () => undefined )
      }
    }, {
      key: 'drawing.catalog_name_changed',
      callback: (msg) => {
        if(msg.detail.id == id) { setCatalogName( () => msg.detail.catalog_name ) }
      }
    }
  ])

  return <div>
    {!hidden && <span style={{marginLeft: '0px'}}
      onClick={handleClick}
      title={ t('my_favourites.add_to_favourites') }
      className={`ribbon ribbon-on-the-left-v2 ${favourited ? 'ribbon-on' : ''} ${inProgress ? 'ribbon-in-progress' : ''}`}></span>}
  </div>
}

export default AddToFavourites;

